import camelCase from 'lodash/camelCase'
import { flatten, merge } from 'lodash'

const requireModuleRoutes = require.context('.', true, /router\/index\.js$/)
const requireModuleStores = require.context('.', true, /store\/index\.js$/)
const requireModuleLocales = require.context(
  '.',
  true,
  /locales\/[A-Za-z0-9-_,\s]+\.json$/i
)

export const routes = flatten(
  requireModuleRoutes
    .keys()
    .map(fileName => requireModuleRoutes(fileName).default)
)

export const stores = requireModuleStores.keys().reduce((modules, fileName) => {
  const moduleName = fileName.replace(/^\.\//, '').split('/')[0]

  modules[camelCase(moduleName)] = {
    namespaced: true,
    ...requireModuleStores(fileName)
  }

  return modules
}, {})

export const locales = requireModuleLocales
  .keys()
  .reduce((messages, fileName) => {
    const matched = fileName.match(/([A-Za-z0-9-_]+)\.json$/i)

    if (matched && matched.length > 1) {
      const locale = matched[1]

      messages[locale] = merge(
        {},
        messages[locale] || {},
        requireModuleLocales(fileName)
      )
    }

    return messages
  }, {})
